import { isRequestError } from '@/helpers/axios';

export const hasLaravelErrors = error => {
	return (
		isRequestError(error) &&
		error.response &&
		error.response.data &&
		(error.response.data.errors || error.response.data.error) &&
		error.response.status == 400
	);
}

class LaravelErrors {

	constructor(error) {
		this.rawLaravelErrors = error.response.data;
		this.errors = this.processErrors();
	}

	getOne(errorKey = null) {
		if(errorKey) {
			return (this.has(errorKey) ? this.get(errorKey)[0] : null);
		} else {
			return (!this.isEmpty() ? this.errors[0] : null);
		}
	}

	all() {
		return this.errors;
	}

	get(errorKey) {
		return this.errors.filter(error => error.key == errorKey);
	}

	has(errorKey) {
		return this.get(errorKey).length > 0;
	}

	isEmpty() {
		return this.errors.length == 0;
	}

	processErrors() {

		let rawErrors;

		if(this.rawLaravelErrors.errors) {

			rawErrors = this.rawLaravelErrors.errors;

			return Object.keys(rawErrors)
				.map(key => ({ key: key, message: rawErrors[key] }));
		}

		return [];
	}

}

export { LaravelErrors }



// WEBPACK FOOTER //
// ./src/helpers/laravel-errors.js